import React, { useState } from 'react';
import { useFieldArray } from 'react-hook-form';
import { Col } from 'react-bootstrap';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';

export default function Composition({ nestIndex, control, register, setValue, compositionListObj, onCompositionChange }) {
  const { fields, remove, append } = useFieldArray({
    control,
    name: `bomForm[${nestIndex}].composition`,
  });
  const { t } = useTranslation('common');
  const [compositionFields, setCompositionFields] = useState(fields.composition || [{ percentage: null, composition: null }]);
  const [showPercentageValueError, setShowPercentageValueError] = useState(false);

  // Custom validation function
  const validateTotalPercentage = () => {
    const totalPercentage = compositionFields.reduce((acc, curr) => acc + (parseFloat(curr.percentage) || 0), 0);
    const percentageError = totalPercentage !== 100;
    setShowPercentageValueError(percentageError);
  };

  const handleChangeComposition = (val, i) => {
    setValue(`bomForm[${nestIndex}].composition[${i}].composition`, val, {
      shouldValidate: true,
    });
    if (onCompositionChange && typeof onCompositionChange === 'function') {
      onCompositionChange(nestIndex, val);
    }
  };

  const handlePercentageChange = (val, index) => {
    const updatedFields = [...fields];
    updatedFields[index].percentage = parseFloat(val) || 0;
    setCompositionFields(updatedFields);
    validateTotalPercentage();
  };

  return (
    <>
      {fields.map((item, k) => {
        return (
          <Col key={k} lg={6}>
            <div className="d-flex align-items-start">
              <div className="flex-one-third mr-3">
                <div className="common-input-control">
                  <p className="field-name">{t('COMPOSITION.PERCENTAGE')}</p>
                  <input
                    type="number"
                    name={`bomForm[${nestIndex}].composition[${k}].percentage`}
                    {...register(`bomForm[${nestIndex}].composition[${k}].percentage`, {
                      required: false,
                      valueAsNumber: true,
                    })}
                    defaultValue={item.percentage}
                    placeholder={t('COMPOSITION.PERCENTAGE')}
                    className="form-control"
                    min="0"
                    step="any"
                    onChange={(e) => handlePercentageChange(e.target.value, k)}
                  />
                </div>
                {showPercentageValueError && k === compositionFields.length - 1 && (
                  <span className="error-message">{t('BOM_TYPE_GROUP_VIEW.VALIDATION_ERROR.TOTAL_PERCENTAGE_VALIDATION')}</span>
                )}{' '}
              </div>

              <div className="flex-fill">
                <div className="common-react-select">
                  <p className="field-name">{t('COMPOSITION.COMPOSITION')}</p>

                  <Select
                    {...register(`bomForm[${nestIndex}].composition[${k}].composition`, {
                      required: false,
                    })}
                    name={`bomForm[${nestIndex}].composition[${k}].composition`}
                    defaultValue={item.composition}
                    options={compositionListObj}
                    getOptionLabel={(option) => `${option?.name}`}
                    getOptionValue={(option) => `${option?._id}`}
                    className="common-select"
                    classNamePrefix="common-select"
                    onChange={(val) => {
                      handleChangeComposition(val, k);
                    }}
                    placeholder={t('COMPOSITION.COMPOSITION')} // Use translation
                  />
                </div>
              </div>

              <div className="d-flex mt-25">
                <a
                  href={() => false}
                  onClick={() => {
                    append({
                      percentage: null,
                      composition: null,
                    });
                    if (onCompositionChange && typeof onCompositionChange === 'function') {
                      setTimeout(() => onCompositionChange(nestIndex, null), 0);
                    }
                  }}
                  className="btn btn-outline sm"
                >
                  <span className="icon-Add" />
                </a>

                {k !== 0 && (
                  <a
                    href={() => false}
                    onClick={() => {
                      if (k !== 0) {
                        remove(k);
                        if (onCompositionChange && typeof onCompositionChange === 'function') {
                          setTimeout(() => onCompositionChange(nestIndex, null), 0);
                        }
                      }
                    }}
                    className="btn btn-outline sm"
                  >
                    <span className="icon-Delete" />
                  </a>
                )}
              </div>
            </div>
          </Col>
        );
      })}
    </>
  );
}
